import type { IStyler } from '@alfa-bank/site-util-create-widget/src/models';
import type { ITextV2PublicProps } from '@alfa-bank/site-text-v2/src/models';

export const configDesktop = {
    titleOffset: { marginBottom: 24 } as IStyler,
    titleIconSize: 20,
    titleView: {
        view: 'small',
        styler: { marginRight: 8 },
    } as ITextV2PublicProps,
};

export const configMobile = {
    titleOffset: { marginBottom: 16 } as IStyler,
    titleIconSize: 16,
    titleView: {
        view: 'xsmall',
        styler: { marginRight: 8 },
    } as ITextV2PublicProps,
};
